/**
 * Registrazione del Service Worker per PWA e uso offline.
 * Il SW viene generato da Workbox solo in build di produzione.
 * Controlla gli aggiornamenti spesso (focus, visibilità, intervallo) così l'app
 * si aggiorna senza dover disinstallare/reinstallare la PWA.
 */
const UPDATE_CHECK_INTERVAL_MS = 10 * 1000; // 10 secondi (controllo leggero, non impatta prestazioni)

function setupUpdateChecks(registration) {
  const checkForUpdates = () => registration.update().catch(() => {});

  // Controllo quando l'app torna in primo piano (es. utente riapre la PWA su mobile)
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkForUpdates();
  });
  window.addEventListener("focus", checkForUpdates);

  // Controllo periodico (ogni minuto) così una nuova deploy viene rilevata a breve
  setInterval(checkForUpdates, UPDATE_CHECK_INTERVAL_MS);
}

export function register(config) {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
    return;
  }
  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) return;
          installingWorker.onstatechange = () => {
            if (installingWorker.state === "installed") {
              if (navigator.serviceWorker.controller) {
                if (config?.onUpdate) config.onUpdate(registration);
              } else if (config?.onSuccess) {
                config.onSuccess(registration);
              }
            }
          };
        };
        // Controllo immediato e poi periodico/on focus
        registration.update().catch(() => {});
        setupUpdateChecks(registration);
      })
      .catch((error) => {
        if (config?.onError) config.onError(error);
      });
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
